import { AfterViewInit, Component, OnInit, TemplateRef, ElementRef, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FilterServService } from '../filter-component/filter-serv.service';
import { EnduserService } from 'src/app/core/services/enduser.service';
import { OrgDropdownModalComponent } from 'src/app/modules/team-store-manager/org-dropdown-modal/org-dropdown-modal.component';
import { OrganizationService } from 'src/app/core/services/organization.service';
import { CommonService } from 'src/app/core/services/common.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { StoreService } from 'src/app/core/services/store.service';
import { TeamStoreService } from '../services/team-store.service';
import { environment } from 'src/environments/environment';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Subscription, debounceTime } from 'rxjs';
declare var $: any;
import Swal from 'sweetalert2';
import { ProductService } from 'src/app/core/services/product.service';
import { Location } from '@angular/common';
import { ThirdFormComponent } from '../component/third-form/third-form.component';
import { EditProductComponent } from '../component/edit-product/edit-product.component';
import { MatStepper } from '@angular/material/stepper';
import { UserRegistrationComponent } from '../../user-registration/user-registration.component';
import { UserLoginComponent } from '../../user-login/user-login.component';

@Component({
  selector: 'app-select-team',
  templateUrl: './select-team.component.html',
  styleUrls: ['./select-team.component.scss']
})
export class SelectTeamComponent implements OnInit, AfterViewInit {
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild('stepper') stepper: any;
  @ViewChild(ThirdFormComponent) thirdFormComponent: ThirdFormComponent;
  @ViewChild(EditProductComponent) editProductComponent!: EditProductComponent;

  storeTeamForm: UntypedFormGroup;
  organizationForm: UntypedFormGroup;
  storeDetailForm: UntypedFormGroup;
  phoneNumberSubscription: Subscription;
  public emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
  public phonePattern = "^\\([0-9]{3}\\)\\s[0-9]{3}\\-[0-9]{4}$";
  states: any[] = []
  markets: any[] = []
  productGroups: any[] = []
  searchText: any = ''
  searchTextMark: string;
  public colors: any[] = [];
  organizationArray: any[] = []
  organazationArts: any[] = []
  public dimOrganizations: any[] = [];
  pageSizeOptions: [12, 20, 50, 100]
  productList: any[] = this.filterServ.productList
  userInfo: any;

  selectedOrganization: any = null;
  selectedmarket: any = null;
  color1: any = null;
  color2: any = null;


  shippingSelect: any = '1';
  userObj: any;
  editStoreTab: any;
  dropdownOpen2 = false;
  dropdownOpen = false;

  storeName: string = 'MY STORE ' + this.getRandomInt(1, 100000);

  isEditing: boolean = false;
  categoryList: any[] = [];
  selectedCategory
  status = 'draft';
  getLoginStat: any = false;
  hidePage = false
  userName: string
  userSelectedOrganization: any;

  constructor(private activeRoute: ActivatedRoute, public dialog: MatDialog,
    private formBuilder: FormBuilder, private teamStoreServ: TeamStoreService,
    public filterServ: FilterServService, private commonService: CommonService,
    private endUserService: EnduserService, private organizationService: OrganizationService,
    private sharedService: SharedService, private storeService: StoreService,
    private cdRef: ChangeDetectorRef, private elRef: ElementRef, private route: Router,
    private productService: ProductService,
    private location: Location,
  ) { }


  /**
 * @section Hostlistener
 */

  @HostListener('document:click', ['$event'])
  closeDropdowns(event: MouseEvent) {
    const dropdown1 = document.querySelector('.dropdown1') as HTMLElement;
    const dropdown2 = document.querySelector('.dropdown2') as HTMLElement;

    if (dropdown1 && !dropdown1.contains(event.target as Node)) this.dropdownOpen = false;
    if (dropdown2 && !dropdown2.contains(event.target as Node)) this.dropdownOpen2 = false;
  }


  /**
   * @section Lifecycle hooks
   */

  ngOnInit(): void {

    // localStorage.setItem('selectTeam', 'Y')
    // this.activeRoute.queryParamMap.subscribe(params => {
    //   if (!params.get('getStarted')) this.getLoginStat = false;
    //   else
    //     this.getLoginStat = JSON.parse(params.get('getStarted').replace(/\?$/, ''));
    // });
    // let userObj = JSON.parse(localStorage.getItem("user"))
    // let userId = localStorage.getItem("userId");
    // if (!userId) {
    //   if (this.getLoginStat) {
    //     this.hidePage = true
    //     window.parent.postMessage("open guest login", "*");
    //     window.parent.postMessage("action - reload page", "*");
    //   }
    //   else {
    //     window.parent.postMessage("open login", "*")
    //     window.parent.postMessage("action - reload page", "*");
    //   }
    // }
    // else {
    //   this.userName = userObj?.name
    // }


    this.createForm();
    this.createOrganizationForm();
    this.createStoreDetails();
    this.formatAndSetPhoneNumber();
    this.getStates();
    this.getProductGroups();
    this.getmarkets()
    this.getColors();
    //this.intialization();
    this.getProductCategories();

    // this.storeDetailForm.get('shippingPreference')?.valueChanges.subscribe(value => {
    //   this.updateAddressValidators(value);
    // });


    this.commonService.postIframeHeight();
  }

  ngOnDestroy(): void {
    localStorage.setItem('selectTeam', 'N')
  }

  ngAfterViewInit() {
    this.tabGroup.selectedIndexChange.subscribe(index => {
      this.editStoreTab = index
      if ([0, 1, 2].includes(index)) {
        setTimeout(() => {
          this.filterServ.selectedProductList.forEach((p: any) => this.callRenter(p))
          this.filterServ.productList.forEach((prod) => {
            if (prod.isAdded != 'Y')
              prod.Arts = this.artArrayFetch(this.filterServ.artFromOrg, prod)
            this.callRenter(prod)
          })
          // this.commonService.postHeightToParent("high")
          

        });
      }
    });

    this.commonService.postIframeHeight();
 
    // const observer = new MutationObserver(() => {
    //   this.commonService.postIframeHeight();
    // });

    // observer.observe(document.body, {
    //   childList: true,
    //   subtree: true,
    //   attributes: true,
    // });

  }

  private getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
 * @section Form creation
 */
  // organization
  createOrganizationForm() {
    this.organizationForm = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      address1: [''],
      city: ['', Validators.required],
      state: [''],
      zipCode: ['', Validators.required],
      institutionTypeId: ['0', Validators.required],
      userId: this.userInfo?.id || 0,
    })
  }

  // first step form
  createForm() {
    // this.userObj = JSON.parse(localStorage.getItem("user")) 
    this.storeTeamForm = this.formBuilder.group({
      OrganizationId: new UntypedFormControl('', [Validators.required]),
      DepartmentId: new UntypedFormControl('', [Validators.required]),
      Email: new UntypedFormControl('' , [Validators.required, Validators.pattern(this.emailPattern)]),
      ColorOne: new UntypedFormControl(''),
      ColorTwo: new UntypedFormControl(''),
      storeProducts: new UntypedFormControl([])
    })
    console.log('c');

    this.getAllOrganizationsForEndUsers()
  }
  noWhitespaceValidator(control: AbstractControl) {
    const isWhitespace = (control.value || '').toString().indexOf(' ') >= 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  // final step form
  createStoreDetails() {
    this.storeDetailForm = this.formBuilder.group({
      id: new UntypedFormControl(0),
      stage: new UntypedFormControl(24),
      createType: new UntypedFormControl(5),
      isUserExists: new UntypedFormControl(false),
      name: new UntypedFormControl(this.storeName, Validators.required),
      contactName: new UntypedFormControl(null),
      firstName: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
      lastName: new UntypedFormControl(''),
      _emailId: new UntypedFormControl(''),
      emailId: new UntypedFormControl(this.userObj?.username, [Validators.required, Validators.pattern(this.emailPattern)]),
      phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(this.phonePattern)]),
      organizationName: new UntypedFormControl(''),
      organizationAddress: new UntypedFormControl(null),
      openDate: new UntypedFormControl(null),
      productShippedBy: new UntypedFormControl(null),
      closeDate: new UntypedFormControl(null),
      club: new UntypedFormControl(null),
      shippingPreference: new UntypedFormControl('2'),
      proposedIndividualShippingCharge: new UntypedFormControl(null),
      productsInHandBy: new UntypedFormControl(null),
      shipToAddress: new UntypedFormControl(''),
      shipToAddress1: new UntypedFormControl(''),
      shipToCity: new UntypedFormControl(''),
      shipToState: new UntypedFormControl(''),
      shipToZipCode: new UntypedFormControl(''),
      rebateCheckAddress: new UntypedFormControl(null),
      fundRaisingClaimPreference: new UntypedFormControl(false),
      storeClosureMode: new UntypedFormControl(1),
      availableToCopy: new UntypedFormControl(false),
      teamStoreOwnerId: new UntypedFormControl(null),
      contactMe: new UntypedFormControl(false),
      marketId: new UntypedFormControl(''),
      marketGroupId: new UntypedFormControl(null),
      isCustomSorted: new UntypedFormControl(null),
      customFields: new UntypedFormControl(''),
      status: new UntypedFormControl(this.status),
      isVerifiedUser: new UntypedFormControl(''),
      agreeToTerms: new UntypedFormControl(''),
      fullName: new UntypedFormControl(''),
      userStateRegion: new UntypedFormControl(''),
      action: new UntypedFormControl(''),

    })
  }

  /**
 * @section Get api calls
 */

  getColors() {
    this.storeService.getAvailableInkColors().subscribe({
      next: (res) => {
        this.colors = res.data[0].colors;
      }, error: (err) => console.log(err)
    })
  }

  getProductGroups() {
    this.productService.getAllProductGroups({}).subscribe(
      (response) => {
        this.productGroups = response.body.data;
      },
      (error) => {
      }
    );

  }

  getmarkets() {
    this.storeService.getAllMarkets().subscribe(
      (response: any) => {
        this.markets = response.data;
      },
      (error) => {
      }
    );
  }

  getStates() {
    this.sharedService.getAllStates().subscribe(res => {
      this.states = res.data
    })
  }

  async getProduct() {
    await this.filterServ.getProduct(this.filterServ.filterParams);

    this.filterServ.productList.forEach(product => {
      const firstColor = product.colorList?.[0];
      if (firstColor) {
        this.editProductComponent.checkColor(product, firstColor);
      }
    });
  }


  getAllOrganizationsForEndUsers() {
    // if (!this.storeTeamForm.get('Email').valid) return
    // let email = this.storeTeamForm.value.Email;
    this.endUserService.getAllOrganizations().subscribe(response => {
      // this.userInfo = response.data;
      this.organizationArray = response.data
      // this.organizationArray.unshift({ name: 'Add new Organization', id: 'Add' })
      this.fetchOrganizations()
    })
  }

  fetchOrganizations() {
    console.log("called");

    this.organizationService._getOrganizationListByName().subscribe({
      next: (res) => {
        this.dimOrganizations = res?.data;
        this.organizationArray = [...this.organizationArray,
        ...this.dimOrganizations.filter(item =>
          !this.organizationArray.some(org => org.id === item.id)
        )]
      }, error: (err) => {
        console.log(err);
      }
    })
  }

  /**
 * @section Change functionalities
 */
  onStepChange(stepper: any): void {
    // setTimeout(() => {
    //   let hg = document.documentElement.scrollHeight || document.body.scrollHeight
    //   if (stepper.selectedIndex == 0) window.top.postMessage("height-" + hg + 'px', "*");
    //   if (stepper.selectedIndex == 1) {
    //     if (this.editStoreTab == 0) window.top.postMessage("height-" + hg + 'px', "*");
    //     if (this.editStoreTab == 1) window.top.postMessage("height-" + hg + 'px', "*");
    //     if (this.editStoreTab == 2) window.top.postMessage("height-" + hg + 'px', "*");
    //   }
    //   if (stepper.selectedIndex == 2) window.top.postMessage("height-" + hg + 'px', "*");        ;
    //   this.filterServ.selectedStepIndex = stepper.selectedIndex;
    // });
    setTimeout(() => this.commonService.postIframeHeight(), 200);

    
  }

  onTabChange(event: MatTabChangeEvent) {
    this.filterServ.editStoreTab = event.index;

    // Add a small delay to reinitialize Doogma AFTER DOM renders
    // setTimeout(() => {
    //   const editProductComponent = this.editProductComponent; // via @ViewChild
    //   if (editProductComponent?.reinitializeDoogmaSafely) {
    //     editProductComponent.reinitializeDoogmaSafely();
    //   }
    //   this.commonService.postIframeHeight() 
    // }, 200);

    setTimeout(() => this.commonService.postIframeHeight(), 200);

  }




  intialization() {
    this.commonService.postHeightToParent("low")
    setInterval(() => {
      this.commonService.postHeightToParent("low")
    }, 5000);
  }


  async pageEvent(event: any) {
    this.filterServ.filterParams.per_page = event.pageSize;
    this.filterServ.filterParams.page = event.pageIndex + 1;

    await this.getProduct();

    this.filterServ.productList.forEach((prod: any) => {
      if (prod.isAdded !== 'Y') {
        prod.Arts = this.artArrayFetch(this.filterServ.artFromOrg, prod);
        this.callRenter(prod);
      }
    });
    // this.commonService.postHeightToParent("high")
    this.commonService.postIframeHeight();

  }

  onEmailChange() {
    let email = this.storeTeamForm.get('Email').value
    this.endUserService.getUserInfoByEmaiId(email).subscribe({
      next: (response) => {

        this.storeDetailForm.patchValue({
          isVerifiedUser: response.data.isUserVerified,
          emailId: email,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phoneNumber: response.data.phoneNumber,
        })

      },
      error: () => {
        this.storeDetailForm.patchValue({
          isVerifiedUser: false,
          emailId: email,
          firstName: '',
          lastName: '',
          phoneNumber: '',
        })
      }

    });

  }



  onOrganizationSelect() {
    let selectedOrgId = this.storeTeamForm.get('OrganizationId').value
    const organization = this.findOrganization(selectedOrgId);
    if (organization) {
      this.userSelectedOrganization = organization;
      const { name, address, address1 } = organization
      this.searchText = name
      this.storeDetailForm.controls['organizationName'].setValue(name)
      this.storeDetailForm.controls['organizationAddress'].setValue(address ? address : '' + address1 ? address1 : '')

      setTimeout(() => {
        this.thirdFormComponent.onShippingMethodChange(this.storeDetailForm.value.shippingPreference);
      }, 1000);
      this.filterServ.selectedProductList=[]
    }
    if (selectedOrgId === 'Add') {
      this.storeTeamForm.get('OrganizationId').reset();
      $('#addOrgModal').modal('toggle');
    }
  }

  onMarketSelect() {
    let selectedMarketId = this.storeTeamForm.get('DepartmentId').value;
    const { name } = this.findMarket(selectedMarketId)
    this.searchTextMark = name
  }

  /**
 * @section Reusable functions
 */

  formatAndSetPhoneNumber() {
    this.phoneNumberSubscription = this.storeDetailForm.get('phoneNumber').valueChanges.pipe(
      debounceTime(100)).subscribe(newValue => {
        const phoneString = newValue.replace(/[^0-9]/g, '');
        let newFormattedPhoneString = '';
        if (phoneString.length > 0) {
          newFormattedPhoneString += "(" + phoneString.substr(0, 3);
        }
        if (phoneString.length > 3) {
          newFormattedPhoneString += ") " + phoneString.substr(3, 3);
        }
        if (phoneString.length > 6) {
          newFormattedPhoneString += "-" + phoneString.substr(6, 4);
        }
        this.storeDetailForm.get('phoneNumber').setValue(newFormattedPhoneString);
      });
  }





  findOrganization(organazationId: any) {
    return this.organizationArray.find((org: any) => org.id == organazationId)
  }
  findMarket(marketId: any) {
    return this.productGroups.find((mrkt: any) => mrkt.id == marketId)
  }

  artArrayFetch(arts: any[], prod: any) {
    if (arts.length > 0 && prod.isAdded != 'Y') {
      arts.forEach((art, index) => art['stat'] = index === 0)
      prod['selectedArt'] = arts[0].artUrl
    }

    return arts;
  }

  getColor(product: any) {
    this.callRenter(product);
  }

  clearShipAddress() {
    this.storeDetailForm.controls['shipToAddress'].setValue('')
    this.storeDetailForm.controls['shipToAddress1'].setValue('')
    this.storeDetailForm.controls['shipToState'].setValue('')
    this.storeDetailForm.controls['shipToZipCode'].setValue('')
  }

  checkProduct(product: any, index: any) {
    const updatedArts = product.Arts.map((art: any, i: number) => {
      return i === index ? { ...art, stat: true } : { ...art, stat: false };
    });
    product.Arts = updatedArts;
    if (updatedArts[index].stat) {
      product['selectedArt'] = updatedArts[index].artUrl;
      this.callRenter(product);
    }
  }

  /**
   * @section Upcomming Function
   */
  launchStore() { }


  /**
 * @section Button Submit Functions
 */

  selectTab(index: number) {
    this.tabGroup.selectedIndex = index;
  }


  createNewOrganization() {
    this.organizationForm.controls['userId'].setValue(this.userInfo.id || 0)
    if (this.organizationForm.valid) {
      this.commonService.toggleLoading(true)
      let tempAdd = { ...this.organizationForm.value }
      tempAdd.state = this.states.find(x => x.id == tempAdd.state).name
      tempAdd['country'] = 'US'
      tempAdd['zipCode'] = tempAdd.zipCode
      this.sharedService
        .validateAddress(tempAdd).subscribe((res) => {
          if (res.data.validAddressIndicator) {
            this.endUserService.createOrganization(this.organizationForm.value)
              .subscribe((response) => {
                this.commonService.toggleLoading(false)
                if (response.status == 1) {
                  let obj = response.data;
                  this.organizationArray.push(obj);
                  this.storeTeamForm.patchValue({ OrganizationId: obj.id });
                  this.onOrganizationSelect();
                  this.closeOrganiztionModal()
                  let form = document.getElementById("organizationForm") as HTMLFormElement
                  form.classList.remove('was-validated')
                }

              }, (error) => {
                this.commonService.openErrorSnackBar(error.message, "");
              })
          } else {
            this.commonService.openErrorSnackBar("Organization address is invalid", "")
            this.commonService.toggleLoading(false)
          }
        }, err => {
          this.commonService.toggleLoading(false)
        });
    } else {
      let form = document.getElementById("organizationForm") as HTMLFormElement
      form.classList.add('was-validated')
      this.commonService.openErrorSnackBar("Please enter all required values", "");
    }
  }

  // removeProd(prod: any) {
  //   prod.isAdded = 'N';
  //   this.filterServ.selectedProductList = this.filterServ.selectedProductList.filter((p: any) => p.id != prod.id);
  // }

  removeProd(prod: any) {
    this.filterServ.selectedProductList = this.filterServ.selectedProductList.filter(p =>
      !(p.id === prod.id &&
        p.selectedColor === prod.selectedColor &&
        p.selectedArt === prod.selectedArt)
    );
  }


  addProd(prod: any) {

    prod.uniqueNumber = Date.now();


    const exists = this.filterServ.selectedProductList.some(p =>
      p.id === prod.id &&
      p.selectedColor === prod.selectedColor &&
      p.selectedArt === prod.selectedArt
    );

    if (!exists) {
      this.filterServ.selectedProductList.push({ ...prod });
    }

    console.log(this.filterServ.selectedProductList);
  }



  async mapNext(step: any) {
    if (step === 'first') {
      const { OrganizationId, DepartmentId } = this.storeTeamForm.value;
      this.filterServ.filterParams.markets = DepartmentId;

      // Wait for getProduct to complete
      await this.getProduct();

      this.commonService.toggleLoading(true);

      this.teamStoreServ.createStoreTeam(OrganizationId, DepartmentId).subscribe((data) => {
        this.filterServ.artFromOrg = data.data.organizationArts;

        this.filterServ.selectedProductList.forEach((p: any) => this.callRenter(p));

        this.filterServ.productList.forEach((prod: any) => {
          prod.Arts = this.artArrayFetch(this.filterServ.artFromOrg, prod);
          //this.addProd(prod);
        });

        this.selectTab(0);

        // this.color1 = this.colors.find((c: any) => c.id === data.data.colorOneId);
        // this.color2 = this.colors.find((c: any) => c.id === data.data.colorTwoId);

        this.commonService.toggleLoading(false);
      });
    }

    if (step === 'second') {
      this.storeTeamForm.controls['storeProducts'].setValue(this.filterServ.selectedProductList);
    }
  }



  async IsValidShipToAddress(stepper?: MatStepper): Promise<void> {

    const products = this.filterServ.selectedProductList;
    if (!products.length) {
      this.commonService.openWarningSnackBar("Add at least one product to continue!", '');
      return;
    }
    const formValue = this.storeDetailForm.value;



    if (formValue.action === 'complete' && formValue.shippingPreference == 2 && formValue.status == 'launch') {
      const state = this.getState(formValue.shipToState) || {};
      const tempAdd = {
        address: formValue.shipToAddress,
        address1: formValue.shipToAddress1,
        city: formValue.shipToCity,
        state: state.name,
        country: 'US',
        zipCode: formValue.shipToZipCode,
      };

      if (!tempAdd.address) return;

      this.commonService.toggleLoading(true);

      try {
        const res = await this.sharedService.validateAddress(tempAdd).toPromise();
        if (res.data.validAddressIndicator) {
          this.saveStore();
        } else {
          this.commonService.openErrorSnackBar("Given address is invalid", "");
        }
      } catch (err) {
        this.commonService.openErrorSnackBar("An error occurred while validating the address", "");
      } finally {
        this.commonService.toggleLoading(false);
      }
    } else {
      this.saveStore();
    }
  }



  getState(id) {
    return this.states.find(state => state.id == Number(id))
  }

  statusChanged(status) {
    this.storeDetailForm.patchValue({ status: status })
  }
  saveStore(stepper?) {
    // if (this.storeDetailForm.valid) {

    const products = this.filterServ.selectedProductList;
    if (!products.length) {
      this.commonService.openWarningSnackBar("Add at least one product to continue!", '');
      return;
    }

    // const { marketId } = this.storeTeamForm.value;
      const { fundRaisingClaimPreference, emailId, shippingPreference } = this.storeDetailForm.value;


      this.storeDetailForm.controls['_emailId'].setValue(emailId)
    this.storeDetailForm.controls['marketId'].setValue(this.storeDetailForm.value.marketId)
      this.storeDetailForm.controls['fundRaisingClaimPreference'].setValue(fundRaisingClaimPreference == 'Y' ? true : false)

    if (shippingPreference == '1') this.clearShipAddress();
    let payload = { ...this.storeDetailForm.value }
    // payload['PrimaryColorId'] = this.color1?.id
    // payload['SecondaryColorId'] = this.color2?.id
    payload['GarmentsRequested'] = this.filterServ.selectedProductList.map((data: any) => {
      // let selectedColors = data.colorList.map((clr: any) => { if (clr.stat) return clr.id })
      // let selectedArt = data.Arts.find((art: any) => art.artUrl == data.selectedArt)
      return {
        "discountStatus": 0,
        "mapCode": data.mapCode,
        "productId": data.id,
        "styleName": data.styleName,
        "isDesigned": false,
        "_teamStoreId": 0,
        "personalize": false,
        "isBlank": false,
        "sku": 0,
        "productName": data.name,
        "displayName": data.displayName,
        "color": data?.selectedColor,
        "price": data.price,
        "discount": 0,
        "fundraiserAmount": 0,
        "fundraiserPercentage": 0,
        "decoPrice": "0.00",
        "total": "0.00",
        "artMapping": data?.selectedArt ? data.selectedArt : '',
        "dugmaArt1": data?.selectedArt ? data.selectedArt : '',
        "teamStoreGarmentPersonalizations": [],
        "teamstoreGarmentStatus": 0,
        "rejectionText": null,
        "rejectionCodes": null
      }
    })

    this.commonService.toggleLoading(true);
    this.teamStoreServ.submitTeamStore(payload).subscribe((data: any) => {
      this.commonService.toggleLoading(false);
      if (data.statusCode == 200) {

        let storeId = data?.data?.id
        this.storeDetailForm.patchValue({
          id: storeId
        })
        if (stepper) {
          stepper.next();
          this.thirdFormComponent.ngOnInit()
        } else {
          //localStorage.setItem('selectTeam', 'Y')
          if (this.storeDetailForm.value.isVerifiedUser) {
            this.goToMyStore()
          } else {
            let data = {
              email: this.storeDetailForm.value.emailId,
              phoneNumber: this.storeDetailForm.value.phoneNumber,
              firstName: this.storeDetailForm.value.firstName,
              lastName: this.storeDetailForm.value.lastName
            }
            this.openUserRegistration(data)
            //this.commonService.postIframeHeight();
          }
          this.filterServ.selectedProductList = []
        }

      }
      else {
        this.commonService.openErrorSnackBar(data.message, '')
      }

    })
    // } else {
    //   this.commonService.openWarningSnackBar('Please fill mandatory fields !', '')
    //   this.storeDetailForm.markAllAsTouched();
    // }
  }

  goToMyStore() {
    const isLoggedInUser = JSON.parse(localStorage.getItem('user'));
    if (isLoggedInUser && isLoggedInUser.roles[0].name == "ENDUSER") {
      this.route.navigateByUrl('enduser/useraccount/my-stores');
    } else {
      const data = {
        isFromSelectTeam: true,
        email: this.storeDetailForm.value.emailId
      }
      this.openUserLogin(data)
    }
    this.commonService.postIframeHeight();
  }
  openUserLogin(data): void {
    this.dialog.open(UserLoginComponent, {
      data: data,
      disableClose: true,
      width: '500px',
      height: 'auto',
      maxHeight: '100vh',
      panelClass: 'full-height-dialog'
    });
  }

  openUserRegistration(userData): void {
    this.dialog.open(UserRegistrationComponent, {
      data: userData,
      disableClose: true,
      width: '500px', 
      height: 'auto',  
      maxHeight: '100vh',  
      panelClass: 'full-height-dialog'  
    });
  }
  
  


  /**
 * @section Doogma Codes
 */

  callRenter(product: any) {
    if (this.shouldRenderDoogma(product)) {
      this.renderCanvasForProduct(product.uniqueNumber, product);
      product.hasDoogma = true;
    } else {
      product.hasDoogma = false;
    }
  }

  getInitialParams(item: any): any {
    return {
      dp_product: item?.image[0] || '',
      dp_graphic1: item.selectedArt
    };
  }

  shouldRenderDoogma(item: any): boolean {
    return item?.image?.length > 0 ? true : false
  }

  async renderCanvasForProduct(id: number, item: any): Promise<void> {
    const canvasId = `canvas${id}`;
    const initialParams = this.getInitialParams(item);

    const options = {
      licenseKey: environment.doogmaLicenseKey,
      maxWidth: 150,
      maxHeight: 150,
    };

    try {
      item['isLoading'] = true
      const response = await (window as any).renderCanvas(canvasId, 'ares~reference1', initialParams, options);
      item['isLoading'] = false
      // console.log('Design rendered successfully:', response);
    } catch (error) {
      // console.error('Render failed:', error);
      item['isLoading'] = false
    }
  }

  isDoogmaRendered(item: any): boolean {
    return item?.hasDoogma;
  }


  /**
   * @section Modal Codes
   */
  // common modal
  openDialog(modal: TemplateRef<any>, product?: any) {

    const dialogRef = this.dialog.open(modal, {
      width: '60%',
      data: product,
      panelClass: 'custom-dialog',
    });
    this.commonService.postScrollMessageToParent()

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'proceed') this.selectTab(1);
      if (result == 'Added1') this.selectTab(0);
      if (result == 'removed') this.removeProd(product);
      if (result == 'Added' || result == 'Added1') this.addProd(product);
      if (result == undefined) this.addProd(product);
    });
  }


  // organaization modal
  openOrgDropdownModal() {
    const dialogRef = this.dialog.open(OrgDropdownModalComponent, {
      width: '600px',
    });
    dialogRef.componentInstance.dimOrganizations = this.dimOrganizations;
    dialogRef.componentInstance.organizationSelected.subscribe((organization: any) => {
      this.selectedOrganization = this.dimOrganizations.find(org => org.name === organization).id
      const selectedOrg = this.dimOrganizations.find(org => org.id === this.selectedOrganization);
      this.commonService.toggleLoading(true)
      this.organizationForm.get("userId").setValue(this.userInfo.id || 0)
      this.organizationForm.get("name").setValue(selectedOrg?.name)
      this.organizationForm.get("address").setValue(selectedOrg?.address);
      this.organizationForm.get("address1").setValue(selectedOrg?.address1);
      this.organizationForm.get("city").setValue(selectedOrg?.city);
      this.organizationForm.get("zipCode").setValue(selectedOrg?.zip);
      this.endUserService.createOrganization(this.organizationForm.value).subscribe({
        next: (res) => {
          this.commonService.toggleLoading(false)
        }, error: (err) => {
          this.commonService.openErrorSnackBar(err?.message, "")
          console.log(err)
        }
      })
      this.organizationArray.push(selectedOrg);
      this.onOrganizationSelect();
    });
  }

  closeOrganiztionModal() {
    let form = document.getElementById("organizationForm") as HTMLFormElement
    form.classList.remove('was-validated')
    $('#addOrgModal').modal('hide')
    this.createOrganizationForm()
  }
  goBack() {
    this.location.back();
  }

  updateStoreName() {
    this.commonService.toggleLoading(true)
    this.teamStoreServ.isUniqueTeamStore({ name: this.storeName, TeamStoreId: this.storeDetailForm.value.id || 0}).subscribe(
      (response) => {
        this.commonService.toggleLoading(false)
        if (!response.data) {
          this.isEditing = false;
          this.storeDetailForm.patchValue({ name: this.storeName })
        }else{
          this.commonService.openErrorSnackBar(response.message,'')
        }
      }
    );
  }

  cancelEdit() {
    this.isEditing = false;
    // Optionally: reset storeName to original value if needed
  }

  getProductCategories() {
    this.productService.getProductCategory().subscribe(
      (response) => {
        // this.categoryList = response.body.data;
        // this.categoryList.forEach((cg: any) => cg['stat'] = false)

        var result = response.body.data;
        this.categoryList = []
        result.forEach(el => {
          var o = Object.assign({}, el);
          o.isExpanded = false;
          if (o.parent_id == 0)
            el['stat'] = false
          this.categoryList.push(el)

        });

      }
    );
  }



  chooseFilter(filter: any, stat: string) {
    filter.stat = !filter.stat;
    // Add if selected
    if (!this.filterServ.filterParams[stat].includes(filter.id) && filter.stat) {
      this.filterServ.filterParams[stat].push(filter.id);
    }

    // Remove if deselected
    if (this.filterServ.filterParams[stat].includes(filter.id) && !filter.stat) {
      this.filterServ.filterParams[stat] = this.filterServ.filterParams[stat].filter(id => id !== filter.id);
    }
    if (stat == 'categories') {

      this.categoryList.forEach(item => {
        if (filter.id != item.id) {
          item.stat = false;
        }
      });

      this.filterServ.filterParams.categoryId = this.filterServ.filterParams.categoryId !== filter.id ? filter.id : 0;

    }
    // this.filterServ.getProduct(this.filterServ.filterParams).subscribe();
    this.getProduct();
  }
  updateAddressValidators(shippingType: string): void {
    const requiredFields = ['shipToAddress', 'shipToAddress1', 'shipToCity', 'shipToState', 'shipToZipCode'];

    requiredFields.forEach(field => {
      const control = this.storeDetailForm.get(field);
      if (!control) return;

      if (shippingType === '2') {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    });
  }


}

